import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Card from './styled-components/Card'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import ButtonRow from './styled-components/ButtonRow'
import { ButtonPrimary } from './styled-components/Button'
import EmailText from './EmailText'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import clearLocalStorage from '../clearLocalStorage'
import getEmailFromLocalStorage from '../getEmailFromLocalStorage'
import { analyticsPage } from '../analytics'

class PasswordResetEmailSent extends Component {
  state = {
    goBackToLoginSelector: false
  }

  goBack = () => {
    clearLocalStorage()

    this.setState({ goBackToLoginSelector: true })
  }

  componentDidMount () {
    analyticsPage('ALI Password Reset - Email Sent')
  }

  render () {
    return (
      <Card>
        {this.state.goBackToLoginSelector ? <Redirect to="/" /> : null}

        <div>
          <AnovaLogoSmall />
        </div>

        <TextColumn>
          <HeaderText>Check your email</HeaderText>
          <HeaderTextSmall>
            Follow the instructions sent to<br />
            <EmailText email={this.props.email || getEmailFromLocalStorage() || ''} />
            &nbsp;to reset your password.
          </HeaderTextSmall>
        </TextColumn>
        <ButtonRow>
          <ButtonPrimary onClick={this.goBack} data-password-reset-done-button>
            DONE
          </ButtonPrimary>
        </ButtonRow>

        <TermsOfServiceAndPrivacyPolicy />
      </Card >
    )
  }
}

export default PasswordResetEmailSent
